import { MainAppResource } from './base';

export default function Guard1000FaultGrabWaveform({
  projectCode,
  substationCode,
  externalGuardId
}) {
  return MainAppResource(
    `api/v3/projects/${projectCode}/substations/${substationCode}/guards1000/${externalGuardId}/send_wave_request{/code}`
  );
}
